import{createSlice} from '@reduxjs/toolkit';
import unknown from'../unknown.jpg';

const initialState={
post:[], /*[
{
id:'1',
username:'@malti',
text:'Hello everyone',
date:'12 Jan Sat 2026',
likes:0,
comments:0,
retweets:0,
userLiked: false,
userCommented :false,
userRetweeted:false,
},
],*/
currentUser:{
name:'Maltie Marien',
dob:'Dec, Fri 2026',
location:'Location, Mumbai, India',
profileImg:unknown,
username:'@maltie'
}
};
const chatSlice = createSlice({
name:'post',initialState,
reducers:{
like:(state,action)=>{
   const postlike=state.post.find((p)=>p.id===action.payload);
if(postlike){
if(!postlike.userLiked){
postlike.likes +=1;
postlike.userLiked = true;
}else{
 postlike.likes -=1;  
postlike.userLiked = false;
}
}
},
comment:(state,action)=>{
   console.log('comment action:', action.payload);

   const postlike=state.post.find((p)=>p.id===action.payload);
if(postlike){
   if(!postlike.userCommented){
postlike.comments +=1;
postlike.userCommented = true;
}else{
 postlike.comments -=1;  
postlike.userCommented = false;
}
}
},
retweet:(state,action)=>{
   const postlike=state.post.find((p)=>p.id===action.payload);
if(postlike){
if(!postlike.userRetweeted){
postlike.retweets +=1;
postlike.userRetweeted = true;
}else{
 postlike.retweets -=1;  
postlike.userRetweeted = false;
}
}
}, 
deletepost:(state,action)=>{
   state.post=state.post.filter(
      post=>post.id !==action.payload
   );
},
addPost:(state,action)=>{
   state.post.unshift({
      id:Date.now().toString(),
      username:state.currentUser.name,
      text:action.payload.text,
      profileImg:state.currentUser.profileImg,
      image:action.payload.image || null,
      date:new Date().toLocaleString(),
      likes:0,
comments:0,
retweets:0,
userLiked: false,
userCommented :false,
userRetweeted:false,
retweetFrom:null
   })
},
retweetPost:(state,action)=>{
   const {id, text} = action.payload;
   const post = state.post.find(p=> p.id === id);
   if(post){
       state.post.unshift({
      id:Date.now().toString(),
      text:action.payload.text,
      profileImg:state.currentUser.profileImg,
      username:post.username,//user
      image:action.payload.image || null,
      date:new Date().toLocaleString(),
      likes:0,
comments:0,
retweets:0,
userLiked: false,
userCommented :false,
userRetweeted:false,
retweetFrom:state.currentUser.username,//name
retweetFromUser:post.username
   })
   post.retweets +=1;
}
} ,
setName:(state,action)=>{
state.currentUser.name=action.payload;
},
setDob:(state,action)=>{
state.currentUser.dob=action.payload;
},
setLocation:(state,action)=>{
state.currentUser.location=action.payload;
},
setProfileImg:(state,action)=>{
state.currentUser.profileImg=action.payload;
state.post.forEach(post=>{
   if (post.username === state.currentUser.username){
      post.profileImg=action.payload;
   }

    if (post.retweetFrom === state.currentUser.username){
      post.profileImg=action.payload;
   }
});
},
setCurrentUser:(state,action)=>{
state.currentUser=action.payload;
},
loadDummy:(state,action)=>{
state.post=action.payload;
}
}
})
   console.log(chatSlice.actions);

export const {like,comment,retweet,deletepost,addPost,retweetPost,loadDummy,setCurrentUser,setProfileImg,setDob,setLocation,setName}=chatSlice.actions;
export default chatSlice.reducer;